module.exports = __webpack_public_path__ + "static/scale-model-of-the-edgar-allan-poe-cottage-in-yonkers-new-york-979d21282715b9e45767196fd06d0059.png";